module.exports = __webpack_public_path__ + "img/products.8d0201cf.svg";